<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">
        <!--Ref-->
        <v-text-field
            v-model="item.ref"
            :error-messages="refErrors"
            :label="$t('order.ref')"
        />
      </v-col>

    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">

        <!--          Quantity -->
        <v-text-field
            v-model.number="item.quantity"
            :error-messages="quantityErrors"
            :label="$t('order.quantity')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">

        <!--          Price -->
        <v-text-field
            v-model.number="item.price"
            :error-messages="priceErrors"
            :label="$t('order.unitPrice')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">

        <!--          Resolution -->
        <v-combobox
                v-if="orderresolutionSelectItems"
                v-model="item.resolution"
                :items="orderresolutionSelectItems"
                :error-messages="resolutionErrors"
                :no-data-text="$t('global.no_result')"
                :placeholder="$t('global.no_select')"
                clearable
                :label="$t('order.resolution')"
                item-text="name"
                item-value="@id"
            />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">

        <!--          Quotation -->
        <v-text-field
            v-model="item.quotation"
            :error-messages="quotationErrors"
            :label="$t('order.quotation')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" offset="1">
        <!--            End of production date-->
        <InputDate
            v-model="item.deliveryObjectif"
            :label="$t('order.delivery')"
            :errormessages="deliveryObjectifErrors"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import has from "lodash/has";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import InputDate from "@/components/InputDate.vue";
import { date } from "../../validators/date";
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'PopupStateOrdered',
  mixins: [validationMixin],

  components :{
    InputDate
  },

  props: {
    values: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  mounted(){
    this.orderresolutionGetSelectItems();
  },

  data() {
    return {
      ref: null,
      comment: null,
      price: null,
      resolution: null,
      quantity: null,
      quotation: null,
    }
  },

  computed: {
    isLoading(){
      return this.isLoading_orderresolution
    },
    ...mapFields('orderresolution', {
      orderresolutionSelectItems: 'selectItems',
      isLoading_orderresolution: 'isLoading'
    }),

    item() {
      return this.initialValues || this.values ;
    },

    refErrors() {
      const errors = [];

      if (!this.$v.item.ref.$dirty) return errors;

      has(this.violations, 'ref') && errors.push(this.violations.ref);

      !this.$v.item.ref.required && errors.push(this.$t('global.field_required'));

      return errors;
    },

    deliveryObjectifErrors() {
      const errors = [];
      if (!this.$v.item.deliveryObjectif.$dirty) return errors;
      has(this.violations, 'deliveryObjectif') && errors.push(this.violations.deliveryObjectif);
      return errors;
    },

    priceErrors() {
      const errors = [];

      if (!this.$v.item.price.$dirty) return errors;

      has(this.violations, 'price') && errors.push(this.violations.price);
      !this.$v.item.price.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    resolutionErrors() {
      const errors = [];

      if (!this.$v.item.resolution.$dirty) return errors;

      has(this.violations, 'resolution') && errors.push(this.violations.resolution);


      return errors;
    },
    quantityErrors() {
      const errors = [];

      if (!this.$v.item.quantity.$dirty) return errors;

      has(this.violations, 'quantity') && errors.push(this.violations.quantity);
      !this.$v.item.quantity.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    quotationErrors() {
      const errors = [];

      if (!this.$v.item.quotation.$dirty) return errors;

      has(this.violations, 'quotation') && errors.push(this.violations.quotation);
      !this.$v.item.quotation.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);

      return errors;
    },
    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
      orderresolutionGetSelectItems: 'orderresolution/fetchSelectItems'
    })
  },

  validations: {
    item: {
      ref: {
        required,
      },
      price: {
        required,
      },
      resolution: {
      },
      quantity: {
        required,
      },
      quotation: {
        required,
      },
      deliveryObjectif: {
        date,
      },
    }
  }
}
</script>

